// import ga from '../js/google-analyze'

const plugin = Vue => {
  Vue.directive('ga', {
    bind(el, binding) {
      el.addEventListener('click', () => {
      })
    },

    unbind(el) {
      el.removeEventListener('click', () => {})
    },
  })
}

export default plugin
